var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Com_view"},[_c('div',{staticClass:"box_header"}),_c('div',{staticClass:"box_section"},[_vm._m(0),_c('div',{staticClass:"box_map"},[_c('dv-flyline-chart-enhanced',{staticStyle:{"width":"100%","height":"100%","margin":"0 auto"},attrs:{"dev":true,"config":_vm.config}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box_title"},[_c('span',[_vm._v("拥有5000+合作伙伴 / 产品分布范围广")])])
}]

export { render, staticRenderFns }